import { render } from "./PaymentComponent.vue?vue&type=template&id=20c4c5f8&scoped=true"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"

import "./PaymentComponent.vue?vue&type=style&index=0&id=20c4c5f8&scoped=true&lang=css"
import "./PaymentComponent.vue?vue&type=style&index=1&id=20c4c5f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c4c5f8"]])

export default __exports__